/**
 * Keys that are not stored per environment type
 */
export enum RawLocalStorageKeys {
    flightSearchRecentlySearchedOriginStations= "flightSearch.recentlySearchedOriginStations",
    flightSearchRecentlySearchedDestinationStations = "flightSearch.recentlySearchedDestinationStations",
    userProfileCurrency = "userProfile.currency",
    themePreferredColorScheme = "theme.preferredColorScheme"
}

